import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/header";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InitialSetup from "../Initialsetup/initialsetup";
import { FaTimes, FaUpload, FaEdit, FaEye, FaTrash, FaFilePdf, FaPlus } from "react-icons/fa";
import { hasPrivilege } from "../../utils/privileges";
import * as XLSX from "xlsx";
import "./additionofemp.css";

const EmployeeView = () => {
    const [schemes, setSchemes] = useState([]);
    const [selectedSchemeId, setSelectedSchemeId] = useState("");
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const [message, setMessage] = useState("");
    const [excelFile, setExcelFile] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [calculatedPremium, setCalculatedPremium] = useState(0);
    const [gst, setGst] = useState("");
    const [totalPremium, setTotalPremium] = useState(0);
    const [premium, setPremium] = useState(0);
    const [employeeCount, setEmployeeCount] = useState(0);
    const [notification, setNotification] = useState("");
    const [notificationType, setNotificationType] = useState("success");
    const [isExcelUploaded, setIsExcelUploaded] = useState(false);
    const [showInitialSetup, setShowInitialSetup] = useState(false);
    const [initialSetupMode, setInitialSetupMode] = useState("add"); // add / edit / view
    const [editingScheme, setEditingScheme] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [familyDefinition, setFamilyDefinition] = useState({});
    const [isViewMode, setIsViewMode] = useState(false);
    // At the top of your component
    const [isEditMode, setIsEditMode] = useState(false);



    const [noOfChild, setNoOfChild] = useState(0);
    const [showAddEmpPopup, setShowAddEmpPopup] = useState(false);

    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [showDeactivatePopup, setShowDeactivatePopup] = useState(false);
    const [pendingEmployee, setPendingEmployee] = useState(null);
    const [deactivateData, setDeactivateData] = useState({
        emp_id: "",
        emp_name: "",
        last_working_date: "",
        policy_start_date: "",
        policy_end_date: "",
        total_premium: 0,
        prorated_premium: 0
    });

    const [newEmp, setNewEmp] = useState({
        emp_status: 'Active',
        scheme_id: "",
        policy_start_date: "",
        policy_end_date: "",
        gst_percent: "",   // ✅ always scheme GST %
        gst_value: 0,
        emp_id: "",
        emp_email_id: "",
        emp_name: "",
        joining_date: "",
        designation: "",
        phone_number: "",
        gender: "",
        dob: "",
        age: "",
        sum_insured: "",
        sum_insured_bal: "",
        total_premium: "",
        premium: "",
        relation: "",
    });

    const payload = {
        ...newEmp,
        gender: newEmp.gender || "Male", // default to Male if empty
        age: newEmp.age ? parseInt(newEmp.age) : null,
        sum_insured: newEmp.sum_insured ? parseFloat(newEmp.sum_insured) : null,
        sum_insured_bal: newEmp.sum_insured_bal ? parseFloat(newEmp.sum_insured_bal) : null,
        premium: newEmp.premium ? parseFloat(newEmp.premium) : null,
        gst_percent: newEmp.gst_percent ? parseFloat(newEmp.gst_percent) : 0,
        gst_value: newEmp.gst_value ? parseFloat(newEmp.gst_value) : 0,
        total_premium: newEmp.total_premium ? parseFloat(newEmp.total_premium) : null,
    };


    const dependentDobs = [];
    if (newEmp.spouse_dob) dependentDobs.push(newEmp.spouse_dob);
    if (newEmp.parent_dob) dependentDobs.push(newEmp.parent_dob);
    if (newEmp.inlaw_dob) dependentDobs.push(newEmp.inlaw_dob);

    for (let i = 1; i <= noOfChild; i++) {
        if (newEmp[`child_${i}_dob`]) dependentDobs.push(newEmp[`child_${i}_dob`]);
    }
    const templateFile = "/Templates/blukuploadofemp/BulkUploads-ActiveList.xlsx";

    useEffect(() => {
        fetchSchemes();
        fetchEmployees();
    }, []);

    const fetchSchemes = async () => {
        try {
            const res = await fetch("/api/setup/getAll");
            const data = await res.json();
            setSchemes(data.success && Array.isArray(data.rows) ? data.rows : []);
        } catch (err) {
            console.error(err);
        }
    };
    const fetchEmployees = async () => {
        try {
            const res = await fetch("/api/employees/getActive");
            const data = await res.json();
            if (data.success && Array.isArray(data.rows)) setEmployees(data.rows);
        } catch (err) {
            console.error(err);
        }
    };

    const agePremiumMap = [
        { min: 19, max: 35, base: 3577.12 },
        { min: 36, max: 45, base: 3947.46 },
        { min: 46, max: 55, base: 6101.69 },
        { min: 56, max: 60, base: 9948.31 },
        { min: 61, max: 65, base: 13000.0 },
        { min: 66, max: 120, base: 15000.0 }
    ];

    // ✅ Function to get base premium from slabs
    function getBasePremium(age) {
        for (let slab of agePremiumMap) {
            if (age >= slab.min && age <= slab.max) {
                return slab.base;
            }
        }
        return 0;
    }

    // ✅ Age calculation
    function calculateAge(dob) {
        if (!dob) return null;
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    // ✅ Excel date parsing
    function parseExcelDateToISO(date) {
        if (!date) return null;

        if (typeof date === "number") {
            const parsed = XLSX.SSF.parse_date_code(date);
            return new Date(parsed.y, parsed.m - 1, parsed.d).toISOString().split("T")[0];
        }

        if (typeof date === "string") {
            const parts = date.split(/[-/.]/);
            if (parts.length === 3) {
                let [day, month, year] = parts;
                if (year.length === 2) year = "19" + year;
                return new Date(year, month - 1, day).toISOString().split("T")[0];
            }
        }

        return new Date(date).toISOString().split("T")[0];
    }

    // ✅ Handle Excel upload and premium calculation
    const handleEmployeeExcel = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = evt.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

            const employeesMap = {};
            const msPerDay = 1000 * 60 * 60 * 24;

            jsonData.forEach(emp => {
                // Parse dates
                const dob = parseExcelDateToISO(emp.dob || emp.DOB);
                const policyStart = new Date(parseExcelDateToISO(emp.policy_start_date));
                const policyEnd = new Date(parseExcelDateToISO(emp.policy_end_date));
                const joiningDate = new Date(parseExcelDateToISO(emp.joining_date || emp.policy_start_date));

                // Age & base premium
                const age = calculateAge(dob);
                const basePremium = age ? getBasePremium(age) : 0;

                // Active days for prorated calculation
                // Total policy days
                const totalPolicyDays = Math.round((policyEnd - policyStart) / msPerDay) + 1;

                // Active days for each employee/dependent
                const activeDays = Math.round((policyEnd - joiningDate) / msPerDay) + 1;

                // Calculate premium with multiplier
                let multiplier = 1;
                const relation = (emp.relation || "").toLowerCase();
                if (["child", "son", "daughter"].includes(relation)) multiplier = 0.5;

                const premium = ((basePremium * activeDays) / totalPolicyDays) * multiplier;
                emp.premium = +premium.toFixed(2);

                // Calculate premium

                // Group by EmployeeID (case-insensitive)
                const empNo = (emp.empno || emp.EmployeeID || "").toLowerCase();
                if (!employeesMap[empNo]) employeesMap[empNo] = [];
                employeesMap[empNo].push({ ...emp, dob, policyStart, policyEnd, joiningDate });
            });

            // Calculate total premium including dependents
            let totalPremiumSum = 0;
            Object.values(employeesMap).forEach(empGroup => {
                const empPremium = empGroup.reduce((sum, item) => sum + item.premium, 0);
                totalPremiumSum += empPremium;
                empGroup.forEach(item => (item.totalEmployeePremium = empPremium));
            });

            // GST & Grand Total (dynamic)
            const gstVal = gst ? +(totalPremiumSum * (gst / 100)).toFixed(2) : 0;
            const grandTotal = +(totalPremiumSum + gstVal).toFixed(2);

            // Update UI
            setExcelData(Object.values(employeesMap).flat());
            setPremium(totalPremiumSum.toFixed(2)); // 21433.89 ✅
            setGst(gstVal.toFixed(2));              // Dynamic GST
            setTotalPremium(grandTotal.toFixed(2)); // Total with GST
            setEmployeeCount(Object.keys(employeesMap).length);
            setNotification("File selected! Click Upload to add employees.");
            setNotificationType("success");
            setIsExcelUploaded(true);
        };

        reader.readAsBinaryString(file);
    };

    const handleexcelSubmit = async () => {
        if (!excelData.length || !selectedSchemeId)
            return alert("Please select a scheme and upload the Excel file first.");

        try {
            const res = await fetch("/api/employees/uploadExcel", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ scheme_id: selectedSchemeId, employees: excelData }),
            });

            const data = await res.json();

            if (data.success) {
                alert("✅ Employees uploaded successfully!"); // popup stays
                setIsExcelUploaded(true); // enable Submit Premium button
                // Do NOT close the popup here
            } else {
                alert("❌ Failed to upload employees: " + data.message);
            }
        } catch (err) {
            console.error(err);
            alert("Server error while uploading employees!");
        }
    };

    const handleEdit = (scheme) => {
        setIsEditMode(true);
        setIsViewMode(false);

        // Parse family_definition if it exists
        let parsedFamilyDef = {};
        if (!scheme.family_definition) {
            try {
                parsedFamilyDef = JSON.parse(scheme.family_definition);
            } catch (err) {
                console.error("Failed to parse family_definition:", err);
            }
        }
        setFamilyDefinition(parsedFamilyDef);

        // Number of children
        setNoOfChild(scheme.no_of_child || 0);

        // Populate newEmp including spouse/child/parent/inlaw fields explicitly
        setNewEmp({
            ...scheme,
            spouse_name: scheme.spouse_name || "",
            spouse_dob: scheme.spouse_dob || "",
            spouse_age: scheme.spouse_age || "",
            parent_name: scheme.parent_name || "",
            parent_dob: scheme.parent_dob || "",
            parent_age: scheme.parent_age || "",
            inlaw_name: scheme.inlaw_name || "",
            inlaw_dob: scheme.inlaw_dob || "",
            inlaw_age: scheme.inlaw_age || "",
            // Populate children if any
            ...Object.keys(scheme)
                .filter(key => key.startsWith("child_"))
                .reduce((acc, key) => ({ ...acc, [key]: scheme[key] }), {}),
        });

        setShowAddEmpPopup(true);
    };



    const handleView = (scheme) => {
        handleEdit(scheme); // populate all fields
        setIsViewMode(true); // add a state to indicate view mode
        setShowAddEmpPopup(true);
    };


    // 1️⃣ Add this function inside your EmployeeView component
    const handleDelete = async (emp_id) => {
        if (!window.confirm("Are you sure you want to deactivate this employee?")) return;

        try {
            // API call to deactivate employee
            const response = await fetch(`/api/employees/deactivate/${emp_id}`, {
                method: "PUT", // Using PUT for update
            });

            const data = await response.json();

            if (data.success) {
                // Update the employee status in local state
                setEmployees((prevEmployees) =>
                    prevEmployees.map((emp) =>
                        emp.emp_id === emp_id ? { ...emp, emp_status: "Inactive" } : emp
                    )
                );
                alert("Employee deactivated successfully");
            } else {
                alert("Failed to deactivate employee: " + data.message);
            }
        } catch (error) {
            console.error("Deactivate error:", error);
            alert("Something went wrong while deactivating the employee.");
        }
    };




    const handlePremiumSubmit = async () => {
        if (!selectedSchemeId) {
            return alert("❌ No scheme selected for premium submission!");
        }

        if (!excelData.length || !premium || !gst || !totalPremium) {
            return alert("❌ Please upload Excel and calculate premium before submitting!");
        }

        const payload = {
            scheme_id: selectedSchemeId,
            premium: parseFloat(premium),
            gst: parseFloat(gst),
            total_premium: parseFloat(totalPremium),
            emp_status: newEmp.emp_status || "Active"

        };

        try {
            const res = await fetch("/api/setup/updatescheme", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const data = await res.json();

            if (data.success) {
                alert("✅ Premium submitted successfully for selected scheme!");

                // Update state immediately from backend response (if API returns updated values)
                if (data.updatedValues) {
                    setPremium(data.updatedValues.premium);
                    setGst(data.updatedValues.gst);
                    setTotalPremium(data.updatedValues.total_premium);
                }

                // Close popup after submission
                setShowUploadPopup(false);

            } else {
                alert("❌ Failed to submit premium: " + data.message);
            }
        } catch (err) {
            console.error(err);
            alert("❌ Server error while submitting premium!");
        }
    };
    const handleOpenUploadPopup = (scheme) => {
        setSelectedSchemeId(scheme.scheme_id);
        setGst(scheme.gst || 0); // <-- populate GST from scheme
        setShowUploadPopup(true);
    };

    const handleOpenAddEmployeePopup = (scheme) => {
        try {
            const parsedFamilyDef = scheme.family_definition
                ? JSON.parse(scheme.family_definition)
                : {};
            setFamilyDefinition(parsedFamilyDef);
            setNoOfChild(scheme.no_of_child || 0);

            const normalizeDate = (d) => (d ? String(d).substring(0, 10) : "");

            setNewEmp((prev) => ({
                ...prev,
                scheme_id: scheme.scheme_id || "",
                policy_start_date: normalizeDate(scheme.policy_start_date),
                policy_end_date: normalizeDate(scheme.policy_end_date),
                emp_id: "",
                emp_email_id: "",
                emp_name: "",
                joining_date: "",
                designation: "",
                phone_number: "",
                gender: "",
                dob: "",
                age: "",
                sum_insured: "",
                sum_insured_bal: "",
                total_premium: "",
                premium: "",
                relation: "",
            }));

            setShowAddEmpPopup(true);
        } catch (err) {
            console.error("Error parsing family definition:", err);
        }
    };

    // ✅ Safe Age Calculation
    const safeCalculateAge = (dob, refDate) => {
        if (!dob) return null;
        const d = new Date(dob);
        const r = new Date(refDate);
        if (isNaN(d) || isNaN(r)) return null;
        let age = r.getFullYear() - d.getFullYear();
        if (
            r.getMonth() < d.getMonth() ||
            (r.getMonth() === d.getMonth() && r.getDate() < d.getDate())
        ) {
            age--;
        }
        return age;
    };

    // ✅ Premium Slabs
    const getPremiumForAge = (age) => {
        if (!age) return 0;
        const slabs = [
            { min: 19, max: 35, base: 3577.12 },
            { min: 36, max: 45, base: 3947.46 },
            { min: 46, max: 55, base: 6101.69 },
            { min: 56, max: 60, base: 9948.31 },
            { min: 61, max: 65, base: 13000 },
            { min: 66, max: 120, base: 15000 },
        ];
        const slab = slabs.find((s) => age >= s.min && age <= s.max);
        return slab ? slab.base : 0;
    };

    
    // ✅ Main Premium Calculation
    const calculatePremium = () => {
        const join = newEmp.joining_date;
        const start = newEmp.policy_start_date;
        const end = newEmp.policy_end_date;
        const gstPercent = Number(newEmp.gst_percent || gst || 0); // use scheme GST % or state gst

        if (!join || !start || !end) return;

        // ✅ Step 1: Base premium (for one member, from employee age slab)
        let basePremium = 0;
        const empAge = safeCalculateAge(newEmp.dob, join);
        if (empAge !== null) {
            basePremium = getPremiumForAge(empAge);
        }

        // ✅ Step 2: Count all members (employee always included)
        let memberCount = 1; // employee
        if (newEmp.spouse_dob) memberCount++;
        if (newEmp.parent_dob) memberCount++;
        if (newEmp.inlaw_dob) memberCount++;

        for (let i = 1; i <= noOfChild; i++) {
            if (newEmp[`child_${i}_dob`]) {
                memberCount++;
            }
        }

        // ✅ Step 3: Premium for all members
        let premium = basePremium * memberCount;

        // ✅ Step 4: Apply pro-rata (if required)
        const s = new Date(start);
        const e = new Date(end);
        const j = new Date(join);

        const totalDays = (e - s) / (1000 * 60 * 60 * 24) + 1;
        const activeDays = (e - j) / (1000 * 60 * 60 * 24) + 1;
        const proRataFactor = activeDays / totalDays;

        premium = premium * proRataFactor;

        // ✅ Step 5: GST calculation
        const gstVal = +(premium * (gstPercent / 100)).toFixed(2);
        const totalWithGst = +(premium + gstVal).toFixed(2);

        // ✅ Step 6: Store values
        setNewEmp((prev) => ({
            ...prev,
            premium: basePremium.toFixed(2),        // single-member premium
            member_count: memberCount,              // new field for clarity
            gst_percent: gstPercent,
            gst_value: gstVal.toFixed(2),
            total_premium: totalWithGst.toFixed(2), // total after GST
        }));
    };

    // ✅ Trigger recalculation when inputs change
    useEffect(() => {
        if (newEmp.joining_date || newEmp.dob) {
            calculatePremium();
        }
    }, [
        newEmp.dob,
        newEmp.joining_date,
        newEmp.spouse_dob,
        newEmp.parent_dob,
        newEmp.inlaw_dob,
        noOfChild,
        ...Array.from({ length: noOfChild }, (_, i) => newEmp[`child_${i + 1}_dob`]),
    ]);

    // ✅ DOB handler
    const handleDobChange = (dobValue) => {
        // Update the DOB in state
        setNewEmp((prev) => ({
            ...prev,
            dob: dobValue,
            age: calculateAge(dobValue),
        }));
    };

    // ✅ Re-fetch scheme if popup opened
    useEffect(() => {
        if (showAddEmpPopup && newEmp.scheme_id) {
            fetch(`/api/schemes/${newEmp.scheme_id}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        const scheme = data.scheme;
                        setFamilyDefinition(JSON.parse(scheme.family_definition));
                        setNoOfChild(scheme.no_of_child || 0);

                        setNewEmp((prev) => ({
                            ...prev,
                            gst_percent: Number(scheme.gst) || 0,
                            joining_date: scheme.default_joining_date || prev.joining_date || "",
                            policy_start_date: scheme.start_date || prev.policy_start_date || "",
                            policy_end_date: scheme.end_date || prev.policy_end_date || "",
                        }));

                    }
                })
                .catch((err) => console.error("Error fetching scheme:", err));
        }
    }, [showAddEmpPopup, newEmp.scheme_id]);

    // ✅ Handle Save Employee
    const handleSaveEmployee = async () => {
        if (!newEmp.scheme_id) return alert("❌ Scheme ID is required!");

        // Build payload safely
        const payload = {
            emp_status: newEmp.emp_status || "Active",
            scheme_id: newEmp.scheme_id || null,
            emp_id: newEmp.emp_id || null,
            emp_email_id: newEmp.emp_email_id || null,
            emp_name: newEmp.emp_name || null,
            joining_date: newEmp.joining_date || null,
            designation: newEmp.designation || null,
            phone_number: newEmp.phone_number || null,
            gender: newEmp.gender || "Male",
            dob: newEmp.dob || null,
            age: newEmp.age ? parseInt(newEmp.age) : null,
            sum_insured: newEmp.sum_insured ? parseFloat(newEmp.sum_insured) : null,
            sum_insured_bal: newEmp.sum_insured_bal ? parseFloat(newEmp.sum_insured_bal) : null,
            policy_start_date: newEmp.policy_start_date || null,
            policy_end_date: newEmp.policy_end_date || null,
            premium: newEmp.premium ? parseFloat(newEmp.premium) : null,  // keep base premium
            gst_percent: newEmp.gst_percent !== "" ? parseFloat(newEmp.gst_percent) : 0,
            gst_value: newEmp.gst_value !== "" ? parseFloat(newEmp.gst_value) : 0,
            total_premium: newEmp.total_premium ? parseFloat(newEmp.total_premium) : null, // total including GST
            relation: newEmp.relation || null,
            spouse_name: newEmp.spouse_name || null,
            spouse_dob: newEmp.spouse_dob || null,
            spouse_age: newEmp.spouse_age ? parseInt(newEmp.spouse_age) : null,
            parent_name: newEmp.parent_name || null,
            parent_dob: newEmp.parent_dob || null,
            parent_age: newEmp.parent_age ? parseInt(newEmp.parent_age) : null,
            inlaw_name: newEmp.inlaw_name || null,
            inlaw_dob: newEmp.inlaw_dob || null,
            inlaw_age: newEmp.inlaw_age ? parseInt(newEmp.inlaw_age) : null,
            // Add children dynamically if needed
            ...Object.keys(newEmp)
                .filter(key => key.startsWith("child_"))
                .reduce((acc, key) => ({ ...acc, [key]: newEmp[key] }), {}),
        };

        try {
            const res = await fetch("/api/employees/save", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (data.success) {
                // Check if this is an update or new record
                if (newEmp.emp_id && isEditMode) {
                    alert("✅ Employee updated successfully!"); // ✅ Updated alert
                } else {
                    alert("✅ Employee saved successfully!");   // ✅ New employee
                }
                setShowAddEmpPopup(false);
            } else {
                alert("❌ Failed to save employee: " + data.message);
            }
        } catch (err) {
            console.error("Save employee error:", err);
            alert("❌ Server error while saving employee!");
        }
    };

 
    const handleGstChange = (value) => {
        setGst(value); // keep string for controlled input
        const gstPercent = parseFloat(value) || 0;

        setNewEmp((prev) => {
            const basePremium = parseFloat(prev.premium) || 0;
            const gstValue = +(basePremium * (gstPercent / 100)).toFixed(2);
            const totalPremium = +(basePremium + gstValue).toFixed(2);

            return {
                ...prev,
                gst_percent: gstPercent,
                gst_value: gstValue,
                total_premium: totalPremium,
            };
        });
    };

    // Show initial confirmation popup
    const handleShowConfirm = (emp) => {
        setPendingEmployee(emp);
        setShowConfirmPopup(true);
    };

    // 2️⃣ On Yes → fetch scheme & show deactivate form
    const handleConfirmDeactivate = async () => {
        try {
            const res = await fetch(`/api/employees/details/${pendingEmployee.emp_id}`);
            const empRes = await res.json();

            if (!empRes.success) return alert("Failed to fetch employee data");

            const emp = empRes.data;

            // ✅ Use premium, not total_premium
            setDeactivateData({
                emp_id: emp.emp_id,
                emp_name: emp.emp_name,
                last_working_date: "",
                policy_start_date: emp.policy_start_date,
                policy_end_date: emp.policy_end_date,
                total_premium: emp.premium, // FIXED
                prorated_premium: emp.premium, // FIXED
                insurer_name: emp.insurer_name
            });

            setShowConfirmPopup(false);
            setShowDeactivatePopup(true);

        } catch (err) {
            console.error(err);
            alert("Error fetching employee data");
        }
    };



    // 3️⃣ Handle last working date → recalc prorata
    const handleLastWorkingDateChange = (dateStr) => {
        const lastWorking = new Date(dateStr);
        const start = new Date(deactivateData.policy_start_date);
        const end = new Date(deactivateData.policy_end_date);

        const totalDays = (end - start) / (1000 * 60 * 60 * 24);
        const remainingDays = (end - lastWorking) / (1000 * 60 * 60 * 24);

        const prorated = deactivateData.total_premium * (remainingDays / totalDays);

        setDeactivateData({
            ...deactivateData,
            last_working_date: dateStr,
            prorated_premium: prorated.toFixed(2)
        });
    };




    // 4️⃣ Submit deactivation
    const handleDeactivateSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(`/api/employees/deactivate/${deactivateData.emp_id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    last_working_date: deactivateData.last_working_date,
                    prorated_premium: deactivateData.prorated_premium
                })
            });

            const data = await res.json();

            if (data.success) {
                setEmployees(prev =>
                    prev.map(emp => emp.emp_id === deactivateData.emp_id ? { ...emp, emp_status: "Inactive" } : emp)
                );
                setShowDeactivatePopup(false);
                alert("Employee deactivated. Prorated premium added to CD balance: " + data.prorated_amount);
            } else {
                alert("Failed to deactivate employee: " + data.message);
            }

        } catch (err) {
            console.error(err);
            alert("Error deactivating employee");
        }
    };


    return (
        <div>
            <Header />

            <div className="employee-view-container">
                <div className="scheme-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Scheme Name</th>
                                <th>Policy Name</th>
                                <th>Policy Type</th>
                                <th>Insurer</th>
                                <th>Period</th>
                                <th>Policy No.</th>
                                <th>Status</th>
                                <th>Scheme Doc</th>
                                <th>Premium</th>
                                <th>GST</th>
                                <th>Total Premium</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {schemes.map((scheme) => (
                                <React.Fragment key={scheme.scheme_id}>
                                    {/* Scheme Row */}
                                    <tr>
                                        <td>{scheme.scheme_id}</td>
                                        <td>{scheme.policy_name_customize}</td>
                                        <td>{scheme.policy_type}</td>
                                        <td>{scheme.insurer_name}</td>
                                        <td>
                                            {scheme.policy_start_date && scheme.policy_end_date
                                                ? `${new Date(scheme.policy_start_date).toLocaleDateString()} - ${new Date(
                                                    scheme.policy_end_date
                                                ).toLocaleDateString()}`
                                                : "-"}
                                        </td>
                                        <td>{scheme.policy_number || "-"}</td>
                                        <td>{scheme.status}</td>
                                        <td>
                                            {scheme.scheme_doc ? (
                                                <a
                                                    href={`/uploads/${scheme.scheme_doc}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <FaFilePdf style={{ color: "#E53E3E", marginRight: "5px" }} />
                                                    {scheme.scheme_doc}
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td>{scheme.premium || "-"}</td>
                                        <td>{scheme.gst || "-"}</td>
                                        <td>{scheme.total_premium || "-"}</td>
                                        <td>
                                            {scheme.premium && scheme.total_premium ? (
                                                
                                                <div className="action-icons">
                                                    {(hasPrivilege("Add & Edit Records") || hasPrivilege("Manage User Accounts")) && (
                                                        <button
                                                            className="btn-addemp"
                                                            onClick={() => handleOpenAddEmployeePopup(scheme)}
                                                        >
                                                            Add Employee
                                                        </button>
                                                    )}
                                                   
                                                    

                                                </div>
                                            ) : (
                                                <button onClick={() => handleOpenUploadPopup(scheme)}>
                                                    Upload Employees
                                                </button>


                                            )}
                                        </td>
                                    </tr>
                                    {showAddEmpPopup && (
                                        <div className="add-emp-popup-overlay">
                                            <div className="add-emp-popup-box">
                                                <FaTimes
                                                    style={{
                                                        cursor: "pointer",
                                                        position: "absolute",
                                                        top: "10px",
                                                        right: "10px",
                                                        color: "red",
                                                        fontSize: "20px",
                                                        zIndex: 1001
                                                    }}
                                                    title="Close"
                                                    onClick={() => setShowAddEmpPopup(false)}
                                                />

                                                <h2 className="add-emp-popup-title">Add New Employee</h2>
                                                <form
                                                    // onSubmit={(e) => handleAddEmployeeSubmit(e, newEmp)}
                                                    className="add-emp-popup-form"
                                                >
                                                    {/* Emp ID & Scheme ID */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Emp ID</label>
                                                            <input
                                                                type="text"
                                                                name="emp_id"
                                                                value={newEmp.emp_id || ""}
                                                                onChange={(e) => setNewEmp({ ...newEmp, emp_id: e.target.value })}
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                        <div className="add-emp-form-group">
                                                            <label>Scheme ID</label>
                                                            <input
                                                                type="text"
                                                                name="scheme_id"
                                                                value={newEmp.scheme_id || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, scheme_id: e.target.value })

                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Email & Name */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Email</label>
                                                            <input
                                                                type="email"
                                                                name="emp_email_id"
                                                                value={newEmp.emp_email_id || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, emp_email_id: e.target.value })
                                                                }
                                                            />
                                                        </div>
                                                        <div className="add-emp-form-group">
                                                            <label>Name</label>
                                                            <input
                                                                type="text"
                                                                name="emp_name"
                                                                value={newEmp.emp_name || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, emp_name: e.target.value })
                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Joining Date & Designation */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Joining Date</label>
                                                            <input
                                                                type="date"
                                                                name="joining_date"
                                                                value={newEmp.joining_date || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, joining_date: e.target.value })
                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                        <div className="add-emp-form-group">
                                                            <label>Designation</label>
                                                            <input
                                                                type="text"
                                                                name="designation"
                                                                value={newEmp.designation || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, designation: e.target.value })
                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Phone & Gender */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Phone</label>
                                                            <input
                                                                type="text"
                                                                name="phone_number"
                                                                value={newEmp.phone_number || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, phone_number: e.target.value })
                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                        <div className="add-emp-form-group">
                                                            <label>Gender</label>
                                                            <select
                                                                name="gender"
                                                                value={newEmp.gender || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, gender: e.target.value })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                                <option value="Other">Other</option>
                                                            </select>

                                                        </div>
                                                    </div>

                                                    {/* DOB & Age */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>DOB</label>
                                                            <input
                                                                type="date"
                                                                name="dob"
                                                                value={newEmp.dob || ""}
                                                                onChange={(e) => handleDobChange(e.target.value)}
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                        <div className="add-emp-form-group">
                                                            <label>Age</label>
                                                            <input type="number" name="age" value={newEmp.age || ""} readOnly />

                                                        </div>
                                                    </div>

                                                    {/* Age Band & Sum Insured */}

                                                    {/* Sum Insured Balance & Policy Start Date */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Sum Insured</label>
                                                            <input
                                                                type="number"
                                                                name="sum_insured"
                                                                value={newEmp.sum_insured || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, sum_insured: e.target.value })
                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                        <div className="add-emp-form-group">
                                                            <label>Sum Insured Balance</label>
                                                            <input
                                                                type="number"
                                                                name="sum_insured_bal"
                                                                value={newEmp.sum_insured_bal || ""}
                                                                onChange={(e) =>
                                                                    setNewEmp({ ...newEmp, sum_insured_bal: e.target.value })
                                                                }
                                                                disabled={isViewMode}
                                                            />
                                                        </div>
                                                        {/* Policy Start Date */}
                                                        <div className="add-emp-form-group">
                                                            <label>Policy Start Date</label>
                                                            <input
                                                                type="date"
                                                                name="policy_start_date"
                                                                value={newEmp.policy_start_date || ""}
                                                                disabled={isViewMode}
                                                                readOnly
                                                            />

                                                        </div>

                                                        {/* Policy End Date */}
                                                        <div className="add-emp-form-group">
                                                            <label>Policy End Date</label>
                                                            <input
                                                                type="date"
                                                                name="policy_end_date"
                                                                value={newEmp.policy_end_date || ""}
                                                                disabled={isViewMode}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="add-emp-form-row">
                                                            <div className="add-emp-form-group">
                                                                <label>Employee Status</label>
                                                                <select
                                                                    name="emp_status"
                                                                    value={newEmp.emp_status || "Active"}
                                                                    onChange={(e) => setNewEmp({ ...newEmp, emp_status: e.target.value })}
                                                                >
                                                                    <option value="Active">Active</option>
                                                                    <option value="Inactive">Inactive</option>
                                                                </select>
                                                            </div>
                                                        </div>


                                                    </div>

                                                    {/* Premium, GST, Relation */}
                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Premium (Per Member)</label>
                                                            <input type="number" value={newEmp.premium || ""} readOnly />
                                                        </div>

                                                        <div className="add-emp-form-group">
                                                            <label>Members Covered</label>
                                                            <input type="number" value={newEmp.member_count || 1} readOnly />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>GST (%):</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Enter GST %"
                                                                value={gst || newEmp.gst_percent}
                                                                onChange={(e) => handleGstChange(e.target.value)}
                                                                disabled={isViewMode}
                                                            />
                                                        </div>

                                                    </div>

                                                    <div className="add-emp-form-row">
                                                        <div className="add-emp-form-group">
                                                            <label>Total Premium</label>
                                                            <input type="number" value={newEmp.total_premium || ""} readOnly />
                                                        </div>
                                                    </div>


                                                    {/* 🔥 Dynamic Family Fields */}

                                                    {/* Spouse */}
                                                    {familyDefinition.spouse && (
                                                        <div className="add-emp-form-row">
                                                            <div className="add-emp-form-group">
                                                                <label>Spouse Name</label>
                                                                <input
                                                                    type="text"
                                                                    value={newEmp.spouse_name || ""}
                                                                    onChange={(e) =>
                                                                        setNewEmp({ ...newEmp, spouse_name: e.target.value })
                                                                    }
                                                                    disabled={isViewMode}
                                                                    required
                                                                />
                                                                
                                                            </div>
                                                            <div className="add-emp-form-group">
                                                                <label>Spouse DOB</label>
                                                                <input
                                                                    type="date"
                                                                    value={newEmp.spouse_dob || ""}
                                                                    onChange={(e) => {
                                                                        const dob = e.target.value;
                                                                        const age = calculateAge(dob);
                                                                        setNewEmp({ ...newEmp, spouse_dob: dob, spouse_age: age });
                                                                    }}
                                                                    disabled={isViewMode}
                                                                />
                                                            </div>
                                                            <div className="add-emp-form-group">
                                                                <label>Spouse Age</label>
                                                                <input type="number" value={newEmp.spouse_age || ""} readOnly />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Children */}
                                                    {familyDefinition.child &&
                                                        [...Array(noOfChild)].map((_, index) => (
                                                            <div key={index} className="add-emp-form-row">
                                                                <div className="add-emp-form-group">
                                                                    <label>Child {index + 1} Name</label>
                                                                    <input
                                                                        type="text"
                                                                        value={newEmp[`child_${index + 1}_name`] || ""}
                                                                        onChange={(e) =>
                                                                            setNewEmp({
                                                                                ...newEmp,
                                                                                [`child_${index + 1}_name`]: e.target.value,
                                                                            })
                                                                        }
                                                                        disabled={isViewMode}
                                                                        required
                                                                    />
                                                                </div>
                                                                <div className="add-emp-form-group">
                                                                    <label>Child {index + 1} DOB</label>
                                                                    <input
                                                                        type="date"
                                                                        value={newEmp[`child_${index + 1}_dob`] || ""}
                                                                        onChange={(e) => {
                                                                            const dob = e.target.value;
                                                                            const age = calculateAge(dob);
                                                                            setNewEmp({
                                                                                ...newEmp,
                                                                                [`child_${index + 1}_dob`]: dob,
                                                                                [`child_${index + 1}_age`]: age,
                                                                            });
                                                                        }}
                                                                        disabled={isViewMode}
                                                                    />
                                                                </div>
                                                                <div className="add-emp-form-group">
                                                                    <label>Child {index + 1} Age</label>
                                                                    <input
                                                                        type="number"
                                                                        value={newEmp[`child_${index + 1}_age`] || ""}
                                                                        readOnly
                                                                    />
                                                                </div>
                                                            </div>
                                                        ))}

                                                    {/* Parents */}
                                                    {familyDefinition.parents && (
                                                        <div className="add-emp-form-row">
                                                            <div className="add-emp-form-group">
                                                                <label>Parent Name</label>
                                                                <input
                                                                    type="text"
                                                                    value={newEmp.parent_name || ""}
                                                                    onChange={(e) =>
                                                                        setNewEmp({ ...newEmp, parent_name: e.target.value })
                                                                    }
                                                                    disabled={isViewMode}
                                                                />
                                                            </div>
                                                            <div className="add-emp-form-group">
                                                                <label>Parent DOB</label>
                                                                <input
                                                                    type="date"
                                                                    value={newEmp.parent_dob || ""}
                                                                    onChange={(e) => {
                                                                        const dob = e.target.value;
                                                                        const age = calculateAge(dob);
                                                                        setNewEmp({ ...newEmp, parent_dob: dob, parent_age: age });
                                                                    }}
                                                                    disabled={isViewMode}
                                                                />
                                                            </div>
                                                            <div className="add-emp-form-group">
                                                                <label>Parent Age</label>
                                                                <input type="number" value={newEmp.parent_age || ""} readOnly />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* In-Laws */}
                                                    {familyDefinition.inlaws && (
                                                        <div className="add-emp-form-row">
                                                            <div className="add-emp-form-group">
                                                                <label>In-Law Name</label>
                                                                <input
                                                                    type="text"
                                                                    value={newEmp.inlaw_name || ""}
                                                                    onChange={(e) =>
                                                                        setNewEmp({ ...newEmp, inlaw_name: e.target.value })
                                                                    }
                                                                    disabled={isViewMode}
                                                                />
                                                            </div>
                                                            <div className="add-emp-form-group">
                                                                <label>In-Law DOB</label>
                                                                <input
                                                                    type="date"
                                                                    value={newEmp.inlaw_dob || ""}
                                                                    onChange={(e) => {
                                                                        const dob = e.target.value;
                                                                        const age = calculateAge(dob);
                                                                        setNewEmp({ ...newEmp, inlaw_dob: dob, inlaw_age: age });
                                                                    }}
                                                                    disabled={isViewMode}
                                                                />
                                                            </div>
                                                            <div className="add-emp-form-group">
                                                                <label>In-Law Age</label>
                                                                <input type="number" value={newEmp.inlaw_age || ""} readOnly />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Submit */}
                                                    <div className="add-emp-form-actions">
                                                        <div className="add-emp-form-actions">
                                                            <button type="button" className="btn-submit" onClick={handleSaveEmployee}>
                                                                Save Employee
                                                            </button>
                                                        </div>

                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    )}



                                    {/* Employee Rows for this scheme */}
                                    {/* Employee Rows for this scheme */}
                                    {employees
                                        .filter((emp) => emp.scheme_id === scheme.scheme_id)
                                        .map((emp) => (
                                            <tr key={emp.emp_id} className="employee-row">
                                                <td colSpan="12">
                                                    <div className="employee-card">
                                                        <div className="employee-info">
                                                            <span>ID: {emp.emp_id}</span>
                                                            <span>Name: {emp.emp_name}</span>
                                                            <span>Email: {emp.emp_email_id || "-"}</span>
                                                            <span>Phone: {emp.phone_number || "-"}</span>
                                                            <span>sum insured: {emp.sum_insured || "-"}</span>
                                                            <span>Sum insured balance: {emp.sum_insured_bal || "-"}</span>
                                                        </div>
                                                        <div className="employee-actions">
                                                            <FaEdit
                                                                style={{ cursor: "pointer" }}
                                                                title="Edit"
                                                                onClick={() => handleEdit(emp)}
                                                            />
                                                            <FaEye
                                                                style={{ cursor: "pointer", marginLeft: "8px" }}
                                                                title="View"
                                                                onClick={() => handleView(emp)}
                                                            />
                                                            {hasPrivilege("Delete Records") && (
                                                            <FaTrash
                                                                style={{ cursor: "pointer", marginLeft: "8px", color: "red" }}
                                                                title="Deactivate"
                                                                onClick={() => {
                                                                    setPendingEmployee(emp);
                                                                    setShowConfirmPopup(true);
                                                                }}
                                                            />
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>


            {showUploadPopup && (
                <div className="upload-popup-overlay">
                    <div className="upload-popup-box">
                        <div className="upload-popup-header">
                            <h2>Upload Employees</h2>
                            <FaTimes className="popup-close" onClick={() => setShowUploadPopup(false)} />
                        </div>

                        <div className="upload-popup-body">
                            <p>Download the Excel template, fill it, and upload it here:</p>

                            <div className="excel-row">
                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={handleEmployeeExcel}
                                />
                                <a href={templateFile} download className="download-btn">Download Template</a>
                            </div>

                            <button
                                className="upload-btn"
                                onClick={handleexcelSubmit}
                            >
                                Upload Excel
                            </button>

                            <div className="premium-fields">
                                <div className="form-group">
                                    <label>Premium:</label>
                                    <input type="number" value={premium} readOnly />
                                </div>
                                <div className="form-group">
                                    <label>GST (%):</label>
                                    <input
                                        type="number"
                                        value={gst}          // current GST %
                                        onChange={(e) => setGst(parseFloat(e.target.value))}  // update GST dynamically
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Total Premium:</label>
                                    <input type="number" value={totalPremium} readOnly />
                                </div>

                                <button
                                    className="submit-premium-btn"
                                    onClick={handlePremiumSubmit}
                                    disabled={!isExcelUploaded}  // disabled until Excel is uploaded
                                >
                                    Submit Premium
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showConfirmPopup && pendingEmployee && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Are you sure you want to deactivate {pendingEmployee.emp_name}?</h3>
                        <div className="popup-actions">
                            <button onClick={() => handleConfirmDeactivate()}>Yes</button>
                            <button onClick={() => setShowConfirmPopup(false)}>No</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ✅ Deactivate Form Popup */}
            {showDeactivatePopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        {/* Close Icon inside popup */}
                        <button
                            type="button"
                            className="close-btn"
                            onClick={() => setShowDeactivatePopup(false)}
                        >
                            <FaTimes />
                        </button>

                        <h2>Deactivate Employee</h2>
                        <form onSubmit={handleDeactivateSubmit}>
                            <div className="form-group">
                                <label>Employee ID</label>
                                <input type="text" value={deactivateData.emp_id} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Name</label>
                                <input type="text" value={deactivateData.emp_name} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Last Working Date</label>
                                <input
                                    type="date"
                                    value={deactivateData.last_working_date}
                                    onChange={(e) => handleLastWorkingDateChange(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Policy Start Date</label>
                                <input type="date" value={deactivateData.policy_start_date} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Policy End Date</label>
                                <input type="date" value={deactivateData.policy_end_date} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Total Premium</label>
                                <input type="number" value={deactivateData.total_premium} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Prorated Premium</label>
                                <input type="number" value={deactivateData.prorated_premium} readOnly />
                            </div>
                            <div className="form-actions">
                                <button type="submit">Deactivate Employee</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}





            {showInitialSetup && (
                <InitialSetup
                    scheme={editingScheme}
                    mode={initialSetupMode}
                    onClose={() => setShowInitialSetup(false)}
                    refreshSchemes={fetchSchemes}
                />
            )}

        </div>
    );
};

export default EmployeeView;
